import { stringify } from "uuid";
import Client, { VideoEncoderBatchRequestInterface, VideoEncoderRequestInterface } from "./client";
import { log } from "./logger";
import SocketClient, { RequestProcessInterface } from "./sockets/socket";
import { nanoid } from "nanoid";
import { AxiosResponse } from "axios";

let client: Client = new Client(process.env.HOST);
client.requiresClient();

const socketClient = new SocketClient(process.env.SOCKET_HOST);
const previewClient = new SocketClient(process.env.SOCKET_PREVIEW_HOST);

const brushEncoder = {
  requiresAuthentication: false,
  currentRequestId: "",
  authenticated: false,
  client,
  socketClient,
  nanoid,

  connect(userIdentifier?: string) {
    
    socketClient
      .prepare({
        userIdentifier,
      })
      .then((socket) => {
        client.setSocket(socket.getRoom());
      });
    return this;
  },

  connectPreview(userIdentifier?: string) {
    previewClient.prepare({
      userIdentifier
    }).then((socket) => {
      client.setSocket(socket.getRoom());
    })

    return this;
  },

  enableNotifications(requestId: string, notificationProviderId: number, notificationEmail: string) {
    client.enableNotification(requestId, notificationProviderId, notificationEmail);
  },
  
  token() {
    return client.getAuthToken();
  },

  url(uri: string) {
    return client.getUrl(uri);
  },
  
  download(type: string = "mp4", callback: (response: AxiosResponse<any>) => any = undefined) {
    client.download(this.currentRequestId, type, callback);
  },

  removeAllListeners() {
    socketClient.removeAllListeners();
    previewClient.removeAllListeners();
    return this;
  },
  
  on(eventName: string, callbackFn: (data: any) => any) {
    socketClient.on(eventName, callbackFn);
    previewClient.on(eventName, callbackFn);
    return this;
  },

  authenticate() {
    client.authenticate();
    return this;
  },

  prepareBody(dataBody: VideoEncoderRequestInterface) {
    if (dataBody.id) {
      this.currentRequestId = dataBody.id;
    }
  },

  
  async queueVideo(dataBody: VideoEncoderRequestInterface): Promise<any> {
    this.prepareBody(dataBody);
    return client.encode(dataBody);
  },

  async queueBatch(dataBody: VideoEncoderBatchRequestInterface): Promise<any> {
    return client.encodeBatch(dataBody);
  },

  async generatePreview(dataBody: VideoEncoderRequestInterface): Promise<any> {
    this.prepareBody(dataBody);
    return client.getPreview(dataBody);
  },
};

module.exports = brushEncoder;
